import { Routes, Route, Navigate } from 'react-router-dom';
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import { DashboardLayout } from './components/DashboardLayout';
import SignInPage from './routes/SignIn';
import SignUpPage from './routes/SignUp';
import Dashboard from './routes/Dashboard';
import FeedbackList from './routes/FeedbackList';
import Members from './routes/Members';
import MemberDetail from './routes/MemberDetail';
import MemberDupes from './routes/MemberDupes';
import Settings from './routes/Settings';
import CheckIns from './routes/CheckIns';
import DayPasses from './routes/DayPasses';
import CashPayments from './routes/CashPayments';
import PublicCheckIn from './routes/PublicCheckIn';
import Coaches from './routes/Coaches';
import Schedule from './routes/Schedule';
import Waivers from './routes/Waivers';
import SignWaiver from './routes/SignWaiver';
import Store from './routes/Store';
import Social from './routes/Social';
import Reports from './routes/Reports';
import Notifications from './routes/Notifications';
import Events from './routes/Events';
import EventDetail from './routes/EventDetail';
import PublicSignup from './routes/PublicSignup';
import PublicDonate from './routes/PublicDonate';
import PublicDonateThanks from './routes/PublicDonateThanks';
import SessionRollCall from './routes/SessionRollCall';
import MyAccount from './routes/MyAccount';
import HouseholdsPage from './routes/Households';
import OrgsPage from './routes/Orgs';
import TeamPage from './routes/Team';
import AuditLogPage from './routes/AuditLog';
import DataRequestsPage from './routes/DataRequests';
import { PermissionsProvider } from './hooks/usePermissions';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* Public surfaces (no auth) */}
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="/checkin" element={<PublicCheckIn />} />
      <Route path="/waiver" element={<SignWaiver />} />
      <Route path="/signup" element={<PublicSignup />} />
      <Route path="/donate" element={<PublicDonate />} />
      <Route path="/donate/thanks" element={<PublicDonateThanks />} />

      {/* Member self-service portal (auth required, but no admin/dashboard layout) */}
      <Route
        path="/my"
        element={
          <>
            <SignedIn><MyAccount /></SignedIn>
            <SignedOut><RedirectToSignIn /></SignedOut>
          </>
        }
      />

      {/* Auth-gated dashboard surface */}
      <Route
        path="/dashboard"
        element={
          <>
            <SignedIn>
              <PermissionsProvider>
                <DashboardLayout />
              </PermissionsProvider>
            </SignedIn>
            <SignedOut>
              <RedirectToSignIn />
            </SignedOut>
          </>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="feedback" element={<FeedbackList />} />
        <Route path="members" element={<Members />} />
        <Route path="members/dupes" element={<MemberDupes />} />
        <Route path="households" element={<HouseholdsPage />} />
        <Route path="orgs" element={<OrgsPage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="audit-log" element={<AuditLogPage />} />
        <Route path="data-requests" element={<DataRequestsPage />} />
        <Route path="members/:id" element={<MemberDetail />} />
        <Route path="checkins" element={<CheckIns />} />
        <Route path="day-passes" element={<DayPasses />} />
        <Route path="cash" element={<CashPayments />} />
        <Route path="schedule" element={<Schedule />} />
        <Route path="schedule/:id" element={<SessionRollCall />} />
        <Route path="events" element={<Events />} />
        <Route path="events/:id" element={<EventDetail />} />
        <Route path="coaches" element={<Coaches />} />
        <Route path="waivers" element={<Waivers />} />
        <Route path="store" element={<Store />} />
        <Route path="social" element={<Social />} />
        <Route path="reports" element={<Reports />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}
